import { Box, Container } from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";

const EventSettings = () => {
  return (
    <Container>
      <BackBtn />
      <Box></Box>
    </Container>
  );
};

export default EventSettings;
